export const ADDITIONAL_LANGUAGES = [
  'groovy',
  'ruby',
  'kotlin',
  'php',
  'java',
  'dart',
  'json',
  'perl',
  'rust',
  'haml',
  'swift',
  'csharp'
]

export type LANGUAGE_TYPE =
  | 'markup'
  | 'bash'
  | 'clike'
  | 'c'
  | 'cpp'
  | 'css'
  | 'javascript'
  | 'jsx'
  | 'coffeescript'
  | 'actionscript'
  | 'css-extr'
  | 'diff'
  | 'git'
  | 'go'
  | 'graphql'
  | 'handlebars'
  | 'json'
  | 'less'
  | 'makefile'
  | 'markdown'
  | 'objectivec'
  | 'ocaml'
  | 'python'
  | 'reason'
  | 'sass'
  | 'scss'
  | 'sql'
  | 'stylus'
  | 'tsx'
  | 'typescript'
  | 'wasm'
  | 'yaml'

export const getBadgeColor = (language: string) => {
  switch (language) {
  case 'css':
  case 'java':
  case 'ruby':
    return {
      bgcolor: '#ff9800',
      color: '#fff'
    }
  case 'jsx':
    return {
      bgcolor: '#61dafb'
    }
  case 'ts':
  case 'tsx':
  case 'typescript':
    return {
      bgcolor: '#294e80',
      color: '#fff'
    }
  case 'graphql':
    return {
      bgcolor: '#e10098',
      color: '#fff'
    }
  case 'go':
  case 'groovy':
  case 'objectivec':
    return {
      bgcolor: '#e8bd36'
    }
  case 'dart':
  case 'kotlin':
  case 'swift':
    return {
      bgcolor: '#005a9c',
      color: '#fff'
    }
  case 'mdx':
    return {
      bgcolor: '#f9ac00',
      color: '#fff'
    }
  case 'rust':
    return {
      bgcolor: '#b7410e',
      color: '#fff'
    }
  case 'yaml':
  case 'yml':
    return {
      bgcolor: '#ffa8df'
    }
  default:
    return {
      bgcolor: '#f7df1e'
    }
  }
}
